export { default } from "./HiddenInput.js";
